// Internal Dependencies
import {
  GET_MASTER_NAME,
  ADD_MASTER_NAME,
  UPDATE_MASTER_NAME,
  DELETE_MASTER_NAME,
  LOADING_MASTER_NAME,
} from '../../actions/types';

const initalizeState = {
  masterNames: [],
  loading:     true,
  error:       {},
  updatedAt:   new Date(),
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOADING_MASTER_NAME:
      return {
        ...state,
        loading: true,
      };
    case GET_MASTER_NAME:
      return {
        ...state,
        masterNames: payload.rows,
        loading:     false,
      };
    case ADD_MASTER_NAME:
      return {
        ...state,
        masterNames: [payload, ...state.masterNames],
        loading:     false,
        updatedAt:   new Date(),
      };
    case UPDATE_MASTER_NAME:
      return {
        ...state,
        masterNameInView: payload,
        loading:          false,
        updatedAt:        new Date(),
      };
    case DELETE_MASTER_NAME:
      return {
        ...state,
        masterNames: state.masterNames.filter((masterName) => masterName.id !== payload),
        loading:     false,
        updatedAt:   new Date(),
      };
    default:
      return state;
  }
}
